
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Client } from "@/types/client";

type FormData = Omit<Client, "id" | "created_at" | "updated_at" | "client_assignments">;

interface PassportInfoTabProps {
  formData: FormData;
  onFormChange: (data: Partial<FormData>) => void;
}

export const PassportInfoTab = ({ formData, onFormChange }: PassportInfoTabProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const field = e.target.id;
    
    // تحديث معلومات جواز السفر
    const currentPassportInfo = formData.passport_info || {};
    const updatedPassportInfo = { ...currentPassportInfo, [field]: value };
    
    onFormChange({ passport_info: updatedPassportInfo });
  };

  const getFieldValue = (field: string) => {
    if (!formData.passport_info) return '';
    return formData.passport_info[field] || '';
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">معلومات جواز السفر</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="first_name">الاسم الأول</Label>
          <Input
            id="first_name"
            value={getFieldValue('first_name')}
            onChange={handleChange}
            placeholder="الاسم الأول كما يظهر في الجواز"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="last_name">الاسم الأخير</Label>
          <Input
            id="last_name"
            value={getFieldValue('last_name')}
            onChange={handleChange}
            placeholder="الاسم الأخير كما يظهر في الجواز"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="passport_number">رقم الجواز</Label>
          <Input
            id="passport_number"
            value={getFieldValue('passport_number')}
            onChange={handleChange}
            placeholder="رقم جواز السفر"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="issue_date">تاريخ الإصدار</Label>
          <Input
            id="issue_date"
            type="date"
            value={getFieldValue('issue_date')}
            onChange={handleChange}
          />
        </div>

        <div className="space-y-2 md:col-span-2">
          <Label htmlFor="expiry_date">تاريخ الانتهاء</Label>
          <Input
            id="expiry_date"
            type="date"
            value={getFieldValue('expiry_date')}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
};
